export function addAttributes(inputElement: HTMLElement, mapOfAttributes: Map<string, any>) {
    for (const [key, value] of mapOfAttributes) {
        inputElement.setAttribute(key, value ?? '');
    }
}
